@if (bannerMessage() && !bannerDismissed()) {
  <div class="header-banner {{ bannerTheme() }} d-flex align-items-center">
    <div class="flex-grow-1">
      {{ bannerMessage() }}
    </div>

    <button andButton color="ghost" size="small" (click)="bannerDismissed.set(true)">
      <aiwyn-icon name="x" role="button"></aiwyn-icon>
    </button>
  </div>
}

<div class="header" *ngIf="{ userType: userType$ | async, displayName: userDisplayName$ | async } as userValues">
  <div class="grid-row grid-row--nog grid-row--aic">
    <div class="grid-col grid-col--auto">
      <div class="logo logo--outlined">
        <aiwyn-logo height="50" [showInternalLogo]="true"></aiwyn-logo>
      </div>
    </div>

    <div class="grid-col">
      <nav class="tabs">
        <a
          href="#"
          *ngIf="showEngagementTab$ | async"
          [routerLink]="'/' + ROUTE_TOKEN_MAIN_BASE + '/' + ROUTE_TOKEN_ENGAGEMENTS_BASE"
          class="tabs__link engagements-tab"
          data-cy="engagements-tab"
          routerLinkActive="active"
        >
          Engagements
          <ng-container *ngIf="engagementsTabCount$ | async as engagementTabCount">
            <pill color="red" [dark]="true" size="small" [value]="engagementTabCount"></pill>
          </ng-container>
        </a>
        <a
          *ngIf="showClientRequestsTab$ | async"
          href="#"
          [routerLink]="'/' + ROUTE_TOKEN_MAIN_BASE + '/' + ROUTE_TOKEN_PROJECTS"
          class="tabs__link"
          data-cy="projects-tab"
          routerLinkActive="active"
        >
          Projects
        </a>
        @if (showRequestsTab$ | async) {
          <a
            href="#"
            [routerLink]="'/' + ROUTE_TOKEN_MAIN_BASE + '/' + ROUTE_TOKEN_CXP_TASKS"
            class="tabs__link tasks-tab"
            data-cy="tasks-tab"
            routerLinkActive="active"
          >
            Requests <!-- Tasks is the Legacy name of this tab -->
            @if (requestsTabCount$ | async; as requestsCount) {
              <pill color="red" [dark]="true" size="small" [value]="requestsCount"></pill>
            }
          </a>
        }
        @if (showFilesTab$ | async) {
          <a
            href="#"
            [routerLink]="'/' + ROUTE_TOKEN_MAIN_BASE + '/' + ROUTE_TOKEN_FILES"
            class="tabs__link"
            data-cy="documents-tab"
            routerLinkActive="active"
          >
            Documents
          </a>
        }
        <a
          href="#"
          *ngIf="showInvoicesTab$ | async"
          [routerLink]="'/' + ROUTE_TOKEN_MAIN_BASE + '/' + ROUTE_TOKEN_INVOICES"
          class="tabs__link"
          data-cy="invoices-tab"
          routerLinkActive="active"
        >
          Invoices
        </a>
        <a
          href="#"
          *ngIf="showPaymentsTab$ | async"
          [routerLink]="'/' + ROUTE_TOKEN_MAIN_BASE + '/' + ROUTE_TOKEN_PAYMENTS"
          class="tabs__link"
          data-cy="payments-tab"
          routerLinkActive="active"
          [ngClass]="{ disabled: userValues.userType === UserType.GUEST }"
        >
          Payments
        </a>
        <a
          href="#"
          *ngIf="showSettingsTab$ | async"
          [routerLink]="'/' + ROUTE_TOKEN_MAIN_BASE + '/' + ROUTE_TOKEN_SETTINGS"
          class="tabs__link"
          data-cy="settings-tab"
          [ngClass]="{ disabled: userValues.userType === UserType.GUEST }"
          routerLinkActive="active"
        >
          Settings
        </a>

        <div class="save-method__dropdown">
          <div class="grid-row grid-row--jcc">
            <div class="grid-col grid-col--auto">
              <img src="assets/save-method@2x.png" width="243" height="201" alt="" />
            </div>
          </div>
          <div class="mt--125 p fw--300 tc--darkest">
            To manage your payments, sign in or create an account (it will only take a minute!).
          </div>
          <div class="mt--125 grid-row grid-row--jcc grid-row--smg">
            <div class="grid-col grid-col--auto">
              <button andButton color="primary" (click)="signIn()" type="button" data-cy="sign-in">
                &nbsp;&nbsp;&nbsp;Sign In&nbsp;&nbsp;&nbsp;
              </button>
            </div>
            <div class="grid-col grid-col--auto">
              <button andButton (click)="register()" type="button" data-cy="register">Create Account</button>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <!--    <a-->
    <!--      *ngIf="hasSecureLink$ | async"-->
    <!--      [routerLink]="['/', ROUTE_TOKEN_SECURE_LINK]"-->
    <!--      class="tabs__link secure-link-projects header__vr d-flex flex-row justify-content-center align-items-center"-->
    <!--    >-->
    <!--      Return to shared requests-->
    <!--    </a>-->

    <div class="help-menu">
      <button class="user-nav__toggle" dataSelector="main-header-help-menu-toggle" [matMenuTriggerFor]="help">
        <div class="help-menu-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.22289 4.22289C4.61341 3.83236 5.24658 3.83236 5.6371 4.22289L9.8771 8.46289C10.2676 8.85341 10.2676 9.48658 9.8771 9.8771C9.48658 10.2676 8.85341 10.2676 8.46289 9.8771L4.22289 5.6371C3.83236 5.24658 3.83236 4.61341 4.22289 4.22289Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.1229 14.1229C14.5134 13.7324 15.1466 13.7324 15.5371 14.1229L19.7771 18.3629C20.1676 18.7534 20.1676 19.3866 19.7771 19.7771C19.3866 20.1676 18.7534 20.1676 18.3629 19.7771L14.1229 15.5371C13.7324 15.1466 13.7324 14.5134 14.1229 14.1229Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.7771 4.22289C20.1676 4.61341 20.1676 5.24658 19.7771 5.6371L15.5371 9.8771C15.1466 10.2676 14.5134 10.2676 14.1229 9.8771C13.7324 9.48658 13.7324 8.85341 14.1229 8.46289L18.3629 4.22289C18.7534 3.83236 19.3866 3.83236 19.7771 4.22289Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.0671 4.93291C19.4576 5.32343 19.4576 5.9566 19.0671 6.34712L15.5371 9.87712C15.1466 10.2676 14.5134 10.2676 14.1229 9.87712C13.7324 9.4866 13.7324 8.85343 14.1229 8.46291L17.6529 4.93291C18.0434 4.54238 18.6766 4.54238 19.0671 4.93291Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.8771 14.1229C10.2676 14.5134 10.2676 15.1466 9.8771 15.5371L5.6371 19.7771C5.24658 20.1676 4.61341 20.1676 4.22289 19.7771C3.83236 19.3866 3.83236 18.7534 4.22289 18.3629L8.46289 14.1229C8.85341 13.7324 9.48658 13.7324 9.8771 14.1229Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <span class="user-nav__name">Help</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="8"
          viewBox="0 0 12 12"
          preserveAspectRatio="none"
          class="user-nav__arrow"
        >
          <path fill="currentColor" d="M11.5,2H.5a.5.5,0,0,0-.412.783l5.5,8a.5.5,0,0,0,.824,0l5.5-8A.5.5,0,0,0,11.5,2Z"></path>
        </svg>
      </button>
      <mat-menu #help="matMenu" class="header-drop">
        <a mat-menu-item dataSelector="main-header-help-menu-knowledge-base" class="user-nav__link" href="https://aiwynhelp.zendesk.com/hc/en-us" target="_blank">
          <div class="help-menu-icon help-menu-option-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
                fill="currentColor"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z"
                fill="currentColor"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11 8C11 7.44772 11.4477 7 12 7H12.01C12.5623 7 13.01 7.44772 13.01 8C13.01 8.55228 12.5623 9 12.01 9H12C11.4477 9 11 8.55228 11 8Z"
                fill="currentColor"
              />
            </svg>
          </div>
          Knowledge Base
        </a>

        <!-- Off removes the row rather than restoring the mailto it replaces: that mailto was the
             dead end this work exists to remove, and it addressed Aiwyn rather than the firm. The
             CONTACT US block below is the firm-addressed path. -->
        @if (supportFormEnabled$ | async) {
          <button
            mat-menu-item
            class="user-nav__link user-nav__link--button"
            dataSelector="main-header-help-menu-contact-support"
            type="button"
            (click)="openContactSupport()"
          >
            <div class="help-menu-icon help-menu-option-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.2581 8.02431C11.7926 7.94446 11.3138 8.03194 10.9066 8.27126C10.4994 8.51057 10.1901 8.88628 10.0333 9.33184C9.85006 9.85282 9.27914 10.1266 8.75815 9.94333C8.23716 9.76005 7.96339 9.18914 8.14666 8.66815C8.46013 7.77704 9.07886 7.02562 9.89327 6.54699C10.7077 6.06836 11.6652 5.8934 12.5962 6.0531C13.5273 6.2128 14.3717 6.69685 14.9801 7.41952C15.5883 8.14204 15.9213 9.05647 15.92 10.0009C15.9195 11.5313 14.7849 12.5419 13.9747 13.082C13.5391 13.3725 13.1105 13.586 12.7949 13.7263C12.6356 13.7971 12.5015 13.8508 12.4049 13.8876C12.3565 13.906 12.3173 13.9203 12.2887 13.9305L12.254 13.9427L12.2429 13.9464L12.239 13.9477L12.2375 13.9483C12.2372 13.9484 12.2362 13.9487 11.92 13L12.2362 13.9487C11.7123 14.1233 11.146 13.8402 10.9713 13.3162C10.7968 12.7926 11.0794 12.2267 11.6027 12.0517L11.6014 12.0521C11.6015 12.0521 11.6016 12.052 11.6027 12.0517L11.6187 12.0461C11.6341 12.0406 11.6593 12.0314 11.6929 12.0186C11.7603 11.9929 11.8606 11.9529 11.9826 11.8987C12.2294 11.789 12.5509 11.6275 12.8653 11.4179C13.5549 10.9582 13.92 10.4691 13.92 9.99999L13.92 9.9985C13.9207 9.52618 13.7542 9.06886 13.45 8.70752C13.1459 8.34618 12.7236 8.10416 12.2581 8.02431Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11 17C11 16.4477 11.4477 16 12 16H12.01C12.5623 16 13.01 16.4477 13.01 17C13.01 17.5523 12.5623 18 12.01 18H12C11.4477 18 11 17.5523 11 17Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            Contact Support
          </button>
        }

        <div class="d-flex flex-column ps-10 pe-4 pt-1 background-color-white">
          <p class="small-300 my-1">Aiwyn {{ version$ | async }}</p>

          <button
            andButton
            color="hyperlink"
            size="small"
            role="link"
            class="color-gray-400 px-0 w-fit-content fw-light"
            dataSelector="main-header-help-menu-terms-of-service"
            (click)="legalService.openTermsAndConditions()"
          >
            Terms of Service
          </button>

          <button
            andButton
            color="hyperlink"
            size="small"
            role="link"
            class="color-gray-400 px-0 w-fit-content fw-light"
            dataSelector="main-header-help-menu-privacy-policy"
            (click)="legalService.openPrivacyPolicy()"
          >
            Privacy Policy
          </button>
        </div>
      </mat-menu>
    </div>

    <!--Email Test Mode Indicator-->
    <div class="grid-col grid-col--auto">
      <div class="header__vr">
        <div *ngIf="isTestMode" class="test-mode__disclaimer">Test Mode Enabled</div>
      </div>
    </div>

    <div class="grid-col grid-col--auto">
      <!-- Admin -->
      <div class="user-nav" *ngIf="userValues.userType === UserType.ADMIN">
        <button class="user-nav__toggle" data-cy="admin-menu" [matMenuTriggerFor]="adminMenu">
          <span class="user-nav__name">Admin</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="8"
            viewBox="0 0 12 12"
            preserveAspectRatio="none"
            class="user-nav__arrow"
          >
            <path fill="currentColor" d="M11.5,2H.5a.5.5,0,0,0-.412.783l5.5,8a.5.5,0,0,0,.824,0l5.5-8A.5.5,0,0,0,11.5,2Z"></path>
          </svg>
        </button>

        <mat-menu #adminMenu="matMenu">
          <div class="user-nav__menu">
            <button mat-menu-item (click)="logout()" class="user-nav__link" data-cy="logout">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              Logout
            </button>
          </div>
        </mat-menu>
      </div>

      <!-- Guest -->
      <div class="user-nav" *ngIf="userValues.userType === UserType.GUEST && !configService.isMobile">
        <button (click)="signIn()" type="button" class="text-button user-nav__signin" data-cy="sign-in">Sign In</button>

        <div class="user-nav__label">or</div>

        <button (click)="register()" type="button" class="button user-nav__button" data-cy="register">Create an Account</button>
      </div>

      <!-- Guest and Mobile View-->
      <div mat-menu-item class="user-nav" *ngIf="userValues.userType === UserType.GUEST && configService.isMobile">
        <button class="user-nav__toggle" data-cy="guest-menu" [matMenuTriggerFor]="menu">
          <span class="user-nav__name">Guest</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="8"
            viewBox="0 0 12 12"
            preserveAspectRatio="none"
            class="user-nav__arrow"
          >
            <path fill="currentColor" d="M11.5,2H.5a.5.5,0,0,0-.412.783l5.5,8a.5.5,0,0,0,.824,0l5.5-8A.5.5,0,0,0,11.5,2Z"></path>
          </svg>
        </button>
        <mat-menu #menu="matMenu">
          <div class="user-nav__menu">
            <button mat-menu-item (click)="signIn()" class="user-nav__link" data-cy="sign-in">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              Sign In
            </button>
            <button mat-menu-item (click)="register()" class="user-nav__link" data-cy="register">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              Create Account
            </button>
          </div>
        </mat-menu>
      </div>

      <!-- Contact -->
      <div class="user-nav" *ngIf="userValues.userType === UserType.CONTACT">
        <button class="user-nav__toggle" data-cy="user-menu" [matMenuTriggerFor]="menu">
          <!-- User image can go here -->
          <!--          <img src="https://randomuser.me/api/portraits/men/17.jpg" alt="" class="user-nav__avatar">-->
          <span class="user-nav__name">{{ userValues.displayName }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="8"
            viewBox="0 0 12 12"
            preserveAspectRatio="none"
            class="user-nav__arrow"
          >
            <path fill="currentColor" d="M11.5,2H.5a.5.5,0,0,0-.412.783l5.5,8a.5.5,0,0,0,.824,0l5.5-8A.5.5,0,0,0,11.5,2Z"></path>
          </svg>
        </button>
        <mat-menu #menu="matMenu">
          <div class="user-nav__menu">
            <button
              mat-menu-item
              (click)="goToAccountSettings()"
              class="user-nav__link"
              data-cy="account-settings"
              *ngIf="isNotGoogleAccount$ | async"
            >
              <aiwyn-icon
                name="settings"
                [height]="20"
                [width]="20"
                [stroke]="'var(--color-neutral-700)'"
                class="cursor-pointer me-2"
              ></aiwyn-icon>
              Account Settings
            </button>
            <button
              mat-menu-item
              (click)="addClientKey()"
              *ngIf="!configService.bypassClientKey"
              class="user-nav__link"
              data-cy="link-account"
            >
              <aiwyn-icon
                name="plus-circle"
                [height]="20"
                [width]="20"
                [stroke]="'var(--color-neutral-700)'"
                class="cursor-pointer me-2"
              ></aiwyn-icon>
              Add an Account
            </button>
            @if (firmContact.show) {
              <mat-divider class="color-gray-900"></mat-divider>
              <div class="px-4 pt-1 pb-0 fw-bold small">CONTACT US</div>
              @if (firmContact.email; as firmContactEmail) {
                <a mat-menu-item class="user-nav__link" data-cy="email-customer" [href]="'mailto:' + firmContactEmail">
                  <aiwyn-icon
                    name="envelope"
                    [height]="20"
                    [width]="20"
                    [stroke]="'var(--color-neutral-700)'"
                    class="cursor-pointer me-2"
                  ></aiwyn-icon>
                  Send Email
                </a>
              }
              @if (firmContact.address) {
                <button mat-menu-item class="user-nav__link" data-cy="copy-mailing-address" (click)="copyMailingAddress()">
                  <aiwyn-icon
                    name="home"
                    [height]="20"
                    [width]="20"
                    [stroke]="'var(--color-neutral-700)'"
                    tooltip="Copy the firm's address to the clipboard"
                    class="cursor-pointer me-2"
                  ></aiwyn-icon>
                  Copy Firm Address
                </button>
              }
              <mat-divider class="color-gray-900"></mat-divider>
            }
            <button mat-menu-item (click)="logout()" class="user-nav__link" data-cy="logout">
              <aiwyn-icon
                name="log-out"
                [height]="20"
                [width]="20"
                [stroke]="'var(--color-neutral-700)'"
                class="cursor-pointer me-2"
              ></aiwyn-icon>
              Logout
            </button>
          </div>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
